import { motion, useInView } from 'motion/react';
import { PropsWithChildren, useRef } from 'react';
import styled from 'styled-components';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionYOffsetBlockProps extends PropsWithChildren {
  className?: string;
}

export const MotionYOffsetBlock = ({
  className,
  children,
}: MotionYOffsetBlockProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: ANIMATION_CONFIG.yOffsetBlock.amount,
  });

  return (
    <MotionYOffsetBlockWrapper
      className={className}
      ref={ref}
      initial={{ y: ANIMATION_CONFIG.yOffsetBlock.yOffset, opacity: 0 }}
      animate={
        isInView
          ? { y: 0, opacity: 1 }
          : { y: ANIMATION_CONFIG.yOffsetBlock.yOffset, opacity: 0 }
      }
      transition={{ duration: ANIMATION_CONFIG.yOffsetBlock.duration }}
    >
      {children}
    </MotionYOffsetBlockWrapper>
  );
};

const MotionYOffsetBlockWrapper = styled(motion.div)``;
